module.exports = __webpack_public_path__ + "34736292/img/send-icon.3cfb6275.svg";